<template>
	<b-modal
		no-fade
		ok-only
		ok-title="Asignar"
		title="Asignar Etiquetas"
		id="modal-assign-tags-view"
        @ok="submit"
		>
        <strong>Se asignarán las etiquetas a los servicios seleccionados:</strong>
        <div class="mb-2"><small class="text-muted">Nota: Se conservarán las etiquetas ya marcadas en los servicios</small></div>
        <b-form-group label="Etiquetas:">
            <multiselect
                v-model="tags"
                :options="tagsOpts"
                multiple
                label="text"
                track-by="id"
                placeholder="Todos"
                size="xs"
                taggable
                tag-placeholder="Agregar esta etiqueta a la lista"
                :show-labels="false"
                >
                    <template v-slot:clear >
                        <div class="multiselect__clear" @click="tags = []"></div>
                    </template>
                </multiselect>
        </b-form-group>

        <b-overlay :show="loadingConfirmation" no-wrap></b-overlay>
	</b-modal>
</template>

<script>
import Multiselect from "vue-multiselect";
import api from '../../../api.js'

export default {
	methods: {
		submit() {

            if (this.selected.length == 0) {
				this.$root.showAlert('No hay servicios marcados',{ variant:'warning' })
				return;
			}
            
            if (this.tags.length == 0) {
				this.$root.showAlert('No hay etiquetas selecccionadas',{ variant:'warning' })
				return;
			}

            this.$bvModal.msgBoxConfirm(`¿Estas seguro de continuar?`, {
                title: 'Confirmación',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'Si',
                cancelTitle: 'Cancelar',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
            .then(value => {
                if (value) {
                    let aux = {ids: this.selected, tags : this.tags}
                    this.loadingConfirmation = true
                    api(this).post(`/transport-services/massive-update-tags`, aux ).then(() => {
                        this.$root.showAlert('Asignacion exitosa');
                        this.$root.$emit('bv::refresh::table', 'reservations-index-list');
                        this.$emit('update:selected',[])
                        this.$bvModal.hide('modal-assign-tags-view')
                    }).catch(err => {
                        this.$root.handleRequestError(err)
                    }).finally(() => {
                        this.loadingConfirmation = false
                    });

                    this.tags = []
                }                    
            })
		}
	},
	props: {
		selected: {
			type : Array,
			required: true
		},
	},
	components: { Multiselect  },
	data() {
		return {
            tags: [],
            loadingConfirmation: false
		}
	},
	computed:{
        tagsOpts() {
			return this.$root.auxVars.tagsOpts
		}
	},
	mounted() {
	},
	watch:{
        selected() {}
	}
}
</script>
